import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/PageNotFound/PageNotFound.module.css';

function PageNotFound() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <div className={styles.pageContainer}>
      <Header />
      {/* CONTENT 404 */}
      <main className={styles.contactContent}>
        <div className={styles.contactCard} style={{ padding: '80px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
          <div style={{ fontSize: '6rem', fontWeight: '800', color: 'var(--accent-color)', lineHeight: '1' }}>404</div>
          <h1 style={{ fontSize: '2rem', margin: '0' }}>Ups! Zgubiłeś się?</h1>
          <p style={{ maxWidth: '400px', margin: '0 auto 20px', color: 'var(--text-muted)' }}>
            Strona, której szukasz, nie istnieje lub została przeniesiona w inne miejsce.
          </p>
          <Link to="/" className={styles.socialBtn} style={{ background: 'var(--accent-color)', color: 'white', padding: '15px 40px', fontSize: '1.1rem' }}>
            Wróć na stronę główną
          </Link>
        </div>
      </main>

      {/* FOOTER */}
      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>
          <div className={styles.disclaimer}>
            <p>Błąd 404 - Nie znaleziono strony. Wróć do rozmów na Czateria24 i poznaj nowych ludzi.</p>
          </div>
          <div className={styles.copyright}>© 2026 Czateria24. Wszystkie prawa zastrzeżone.</div>
        </div>
      </footer>
    </div>
  );
};

export default PageNotFound;